<div class="modal-content1">
  <div class="modal-header">
    <div class="d-flex w-100 align-items-center justify-content-between">
      <div class="col-md-10 col">
        <h4 class="modal-title">Manage News</h4>
      </div>
      <div class="col-sm-auto col-auto ml-auto">
        <button type="button" class="close" (click)="onCancel()">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>

  <form [formGroup]="newsForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="modal-body">
      <div class="row">
        <!-- News Title -->
        <div class="col-sm-12">
          <div class="form-group">
            <label for="newsTitle">News Title</label>
            <input
              formControlName="title"
              type="text"
              id="newsTitle"
              class="form-control"
              placeholder="Enter news title"
            />
            <div *ngIf="f.title.touched && f.title.invalid" class="text-danger">
              <div *ngIf="f.title.errors?.required">Title is required</div>
              <div *ngIf="f.title.errors?.maxlength">
                Maximum 500 characters allowed
              </div>
            </div>
          </div>
        </div>

        <!-- News Description -->
        <div class="col-sm-12">
          <div class="form-group">
            <label for="newsDescription">News Description</label>
            <textarea
              formControlName="description"
              id="newsDescription"
              rows="3"
              class="form-control"
              placeholder="Enter news description"
            ></textarea>
            <div
              *ngIf="f.description.touched && f.description.invalid"
              class="text-danger"
            >
              <div *ngIf="f.description.errors?.required">
                Description is required
              </div>
              <div *ngIf="f.description.errors?.maxlength">
                Maximum 1000 characters allowed
              </div>
            </div>
          </div>
        </div>

        <!-- News Details -->
        <div class="col-sm-12">
          <div class="form-group">
            <label for="newsDetails">News Details</label>
            <textarea
              formControlName="details"
              id="newsDetails"
              rows="4"
              class="form-control"
              placeholder="Enter news details"
            ></textarea>
            <div
              *ngIf="f.details.touched && f.details.invalid"
              class="text-danger"
            >
              <div *ngIf="f.details.errors?.required">
                News details are required
              </div>
            </div>
          </div>
        </div>

        <!-- Actual Date -->
        <div class="col-sm-12">
          <div class="form-group">
            <label for="actualDate">Actual Date</label>
            <mat-form-field appearance="fill" class="w-100">
              <input
                matInput
                [matDatepicker]="picker"
                formControlName="actualDate"
                placeholder="Select a date"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <div
              *ngIf="f.actualDate.touched && f.actualDate.invalid"
              class="text-danger"
            >
              <div *ngIf="f.actualDate.errors?.required">
                Actual Date is required
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button
        type="submit"
        class="btn btn-success btn-sm m-right-10"
        [disabled]="newsForm.invalid"
        cdkFocusInitial
      >
        <i class="las la-save"></i> Save
      </button>
      <button type="button" class="btn btn-danger btn-sm" (click)="onCancel()">
        <i class="las la-times-circle"></i> Cancel
      </button>
    </div>
  </form>
</div>
